import React from 'react';
import { Seo, breadcrumbSchema, webPageSchema } from '../components/Seo';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';
import { ELIGIBILITY, TERMS } from '../data/content';

const Eligibility = () => (
  <div data-testid="page-eligibility">
    <Seo
      title="Eligibility · Who Can Enter the AdAura Awards 2026"
      description="Eligibility criteria for the AdAura Awards 2026 — brands, agencies, startups, creators, PR firms and marketing teams. Entry period, geography and campaign requirements explained."
      path="/eligibility"
      jsonLd={[
        webPageSchema({ path: '/eligibility', name: 'Eligibility', description: "Eligibility criteria for the AdAura Awards 2026 — brands, agencies, startups, creators, PR firms and marketing" }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Eligibility', path: '/eligibility' }]),
      ]}
    />
    <PageHeader
      eyebrow="The Fine Print"
      title="Eligibility & Terms"
      italicWords={['Terms']}
      subtitle="The boundaries we have set - and the standards every entry is held to."
    />

    {/* ELIGIBILITY */}
    <section className="pb-20 md:pb-28">
      <div className="content-container">
        <div className="grid grid-cols-12 gap-6 mb-10">
          <div className="col-span-12 md:col-span-4">
            <Reveal><div className="eyebrow mb-5">Section One</div></Reveal>
            <Reveal delay={120}>
              <h2 className="display text-white text-2xl md:text-3xl">
                Eligibility <span className="text-[#C9A56C]">Criteria</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-8" data-testid="eligibility-list">
            {ELIGIBILITY.map((item, i) => (
              <Reveal key={item.k} delay={i * 80} className="border-t border-[#C9A56C]/20 py-8 grid grid-cols-12 gap-6">
                <div className="col-span-2 md:col-span-1">
                  <span className="numeral text-2xl md:text-3xl">{item.k}</span>
                </div>
                <div className="col-span-10 md:col-span-11">
                  {item.title ? (
                    <h3 className="font-serif text-white text-xl md:text-2xl leading-tight">{item.title}</h3>
                  ) : null}
                  <p className={`text-white/75 ${item.title ? 'mt-3' : ''} leading-relaxed font-sans text-[15px] md:text-base`}>{item.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>


    {/* TERMS */}
    <section className="section-pad bg-[#634F3A]">
      <div className="content-container">
        <div className="grid grid-cols-12 gap-6 mb-10">
          <div className="col-span-12 md:col-span-4">
            <Reveal delay={120}>
              <h2 className="display text-white text-2xl md:text-3xl">
                Terms & <span className="text-[#C9A56C]">Conditions</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-8" data-testid="terms-list">
            {TERMS.map((item, i) => (
              <Reveal key={item.k} delay={i * 60} className="border-t border-[#C9A56C]/20 py-7 grid grid-cols-12 gap-6">
                <div className="col-span-2 md:col-span-1">
                  <span className="numeral text-xl md:text-2xl">{item.k}</span>
                </div>
                <div className="col-span-10 md:col-span-11">
                  <p className="text-white/75 leading-relaxed font-sans text-[15px] md:text-base">{item.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Eligibility;
